import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { Booking } from '@yiluhub/yilu-amp-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { yiluEnv } from 'utils/index';

import { BookingTerms } from 'components/BookingConfirmation/components';
import 'components/BookingConfirmation/styles.scss';

import LoungeFaq from 'modules/lounges/components/LoungeFaq';

import { BookingFAQSupport } from './BookingFAQSupport';
import { LoungesBookingInfo } from './LoungesBookingInfo';

type LoungeBookingConfirmationProps = {
  booking: Booking<'COMPLETED', 'LOUNGE'>;
};

export const LoungeBookingConfirmation: React.FC<LoungeBookingConfirmationProps> = ({
  booking,
}) => {
  const { t } = useTranslation();
  const yiluEnvVariables = yiluEnv.getVariables();
  const partnerId = yiluEnvVariables.YILU_ENTERPRISE_PARTNER
    ? yiluEnvVariables.YILU_ENTERPRISE_PARTNER.toUpperCase()
    : 'LH';

  const faqs = Array.from({ length: 3 }, (_, i) => ({
    question: t(`bcp.loungeFaq.question${i + 1}`),
    answer: t(`bcp.loungeFaq.answer${i + 1}`),
  }));
  const bookingData = booking?.product.data;

  const faqLink = 'mailto:lounge-support@lufthansa-group.com';

  return (
    <>
      {bookingData && (
        <>
          <ElementsSDK.Message
            className="yilu-payment-bcp-email-confirmation"
            type={ElementsSDK.MessageType.SUCCESS}
            icon={ElementsSDK.Icon.Email}
            content={t('bcp.lounges.emailConfirmation', {
              email: bookingData.customerDetails.email,
            })}
          />
          <LoungesBookingInfo booking={booking} />
          {booking.product.data.termsUrl && <BookingTerms termsUrl={bookingData.termsUrl} />}
          {(partnerId === 'LH' || partnerId === 'ST') && <LoungeFaq faqs={faqs} />}
          {faqLink && <BookingFAQSupport faqLink={faqLink} />}
        </>
      )}
    </>
  );
};
